export default "{\n    \"label\": \"Grupos de instalaciones\",\n    \"placeholder\": \"Seleccione grupos\"\n}"